import { assertInInjectionContext, inject, Injector, runInInjectionContext, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FeatureFlag } from '../domain/models/feature-flags.enum';
import { FeatureFlagService } from '../util-feature-flag-service/feature-flag.abstract.service';

/**
 * Gets a feature flag as a signal
 *
 * @example
 * flag = featureFlagSignal('Flag');
 *
 * @param flag FeatureFlag
 * @param defaultValue T
 * @param live boolean ( should this update)
 * @param injector Injector
 * @returns Signal<T>
 */
export function featureFlagSignal<T>(flag: FeatureFlag, defaultValue: T, live = false, injector?: Injector): Signal<T> {
  if (!injector) {
    assertInInjectionContext(featureFlagSignal);
  }
  injector ??= inject(Injector);
  const result = runInInjectionContext(injector, () => {
    const service = inject(FeatureFlagService);
    return live ? service.getLiveFeature$(flag, defaultValue) : service.getFeature$(flag, defaultValue);
  });
  return toSignal(result, { initialValue: defaultValue });
}
